module.exports = __webpack_public_path__ + "img/977970_E1D9D8_DAC8C1_C4B2AD-256px.e795e857.png";